<ng-container *transloco="let t; prefix: 'configurations.list-details'">
  @if (selectedConfiguration) {
    <div class="content-padding">
      <div class="config-list-details__page-header">
        <h1 class="kxi-text-large kxi-text-600">
          {{ selectedConfiguration.name }}
          @if (selectedConfiguration.removed) {
            <span class="config-deleted">{{ t('deleted') }}</span>
          }
        </h1>
        @if (!selectedConfiguration.removed) {
          <div>
            <xi-default-button
              [text]="authService.isReadOnly ? t('view') : t('edit')"
              (onClick)="onEditConfiguration()"
            ></xi-default-button>
          </div>
        }
      </div>
      <div class="config-list-details__scroll">
        <div class="config-list-details__content">
          @if (!selectedConfiguration.removed) {
            <div class="config-list-details__card">
              <div class="config-list-details__card-header">
                <h5>{{ t('analytic-items-header') }}</h5>
                <p>{{ t('analytic-items-content') }}</p>
              </div>
              <app-configuration-analytic-items-summary
                [selectedConfiguration]="selectedConfiguration"
                [accountLimits]="accountLimits"
              ></app-configuration-analytic-items-summary>
            </div>
          }
          @if (!selectedConfiguration.removed) {
            <div class="config-list-details__card">
              <div class="config-list-details__card-header">
                <h5>{{ t('activity-header') }}</h5>
                <p>
                  {{ t('activity-content') }}
                </p>
              </div>
              <div>
                <div>
                  <app-configuration-activity-table
                    [configuration]="selectedConfiguration"
                    [configurations]="configurations"
                    [autoAnalysisConfigs]="autoAnalysisConfigs"
                    [projectsCollections]="projectsCollections"
                  ></app-configuration-activity-table>
                </div>
              </div>
            </div>
          }
          <div class="config-list-details__card">
            @if (isConfigLoading) {
              <div
                class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur"
              >
                <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
              </div>
            }
            <div class="config-list-details__card-header">
              <h5>{{ t('general-header') }}</h5>
              <p>{{ t('general-content') }}</p>
            </div>
            <div class="config-list-details__card-content">
              <div class="config-list-details__general-row kxi-text-normal">
                <p class="kxi-text-600">{{ t('description') }}</p>
                <p class="config-list-details__card-description">
                  {{ selectedConfiguration.notes || t('n-a') }}
                </p>
              </div>
              <div class="config-list-details__general-row">
                <p class="kxi-text-600">{{ t('language') }}</p>
                <p>{{ selectedConfiguration.language_name }}</p>
              </div>
              <div class="config-list-details__general-row">
                <p class="kxi-text-600">{{ t('tags') }}</p>
                <div>
                  <app-tag-autowrap
                    class="config-list-details__general-tags"
                    [configuration]="selectedConfiguration"
                  ></app-tag-autowrap>
                  @if (!selectedConfiguration.tags) {
                    <p>{{ t('n-a') }}</p>
                  }
                </div>
              </div>
            </div>
          </div>
          <app-configuration-overview
            [configuration]="selectedConfiguration"
            [isConfigLoading]="isConfigLoading"
          ></app-configuration-overview>
        </div>
      </div>
    </div>
  }
</ng-container>
